/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, November 9th 2021, 2:54:04 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { OSAlert } from "ui-widgets";

const DeveloperModeHeading = () => (
  <div>
    <p>Oops. If this is a production environment, someone has messed up big time!!</p>
    <p>
      Developer Mode: The below errors occurred on the Backend API. Kindly resolve or liase with the backend developers.
      If the error is expected, kindly ignore this message.
    </p>
  </div>
);

export const APIFormDebugger = ({ useAPIFormReturn }) => {
  return (
    <React.Fragment>
      {process.env.NODE_ENV === "development" && Object.keys(useAPIFormReturn?.apiDataSendErrors).length > 0 ? (
        <React.Fragment>
          <br />
          <OSAlert severity="warning">
            <DeveloperModeHeading />
            <p>{JSON.stringify(useAPIFormReturn?.apiDataSendErrors, null, 2)}</p>
          </OSAlert>
        </React.Fragment>
      ) : null}{" "}
    </React.Fragment>
  );
};
